/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Staff chip, derived from item status, document status and participant responses
 * @export
 */
export const StaffItemDisplayStatus = {
    ToDo: 'to_do',
    Requested: 'requested',
    InReview: 'in_review',
    NeedsAnotherLook: 'needs_another_look',
    Accepted: 'accepted',
    Withdrawn: 'withdrawn',
    DoesntApply: 'doesnt_apply',
    CantFind: 'cant_find',
    SomeoneElseHasIt: 'someone_else_has_it',
} as const;
export type StaffItemDisplayStatus = typeof StaffItemDisplayStatus[keyof typeof StaffItemDisplayStatus];


export function instanceOfStaffItemDisplayStatus(value: any): boolean {
    for (const key in StaffItemDisplayStatus) {
        if (Object.prototype.hasOwnProperty.call(StaffItemDisplayStatus, key)) {
            if (StaffItemDisplayStatus[key as keyof typeof StaffItemDisplayStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StaffItemDisplayStatusFromJSON(json: any): StaffItemDisplayStatus {
    return StaffItemDisplayStatusFromJSONTyped(json, false);
}

export function StaffItemDisplayStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffItemDisplayStatus {
    return json as StaffItemDisplayStatus;
}

export function StaffItemDisplayStatusToJSON(value?: StaffItemDisplayStatus | null): any {
    return value as any;
}

export function StaffItemDisplayStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): StaffItemDisplayStatus {
    return value as StaffItemDisplayStatus;
}

